// extracted by mini-css-extract-plugin
module.exports = {"nav-tabs":"settings_nav-tabs__BWwvv","nav-link":"settings_nav-link__3ZWPo","active":"settings_active__1Wbwb"};